import LightbulbIcon from '@mui/icons-material/Lightbulb';
import { styled } from '@mui/material/styles';

// Styled component for the rotating border bulb
const RotatingBorderBulb = styled('div')(({ theme }) => ({
  position: 'relative',
  width: '40px',
  height: '40px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  
  '& .MuiSvgIcon-root': {
    zIndex: 1,
    color: theme.palette.warning.main,
  },
  
  '&::before': {
    content: '""',
    position: 'absolute',
    width: '100%',
    height: '100%',
    border: `2px dashed ${theme.palette.error.main}`,
    borderRadius: '50%',
    animation: 'rotateBorder 3s linear infinite',
  },
  
  '@keyframes rotateBorder': {
    '0%': {
      transform: 'rotate(0deg)',
    },
    '100%': {
      transform: 'rotate(360deg)',
    },
  }
}));

// Usage in your component
const BulbWithRotatingBorder = () => (
  <RotatingBorderBulb>
    <LightbulbIcon />
  </RotatingBorderBulb>
);